export default "__VITE_ASSET__x05WJU$4__"